import React, { useReducer, useContext, useRef, useEffect, useMemo } from 'react';
import DynamicFont from 'react-dynamic-font';
import { CusButton } from '../../Components/From/Button';
import { FormattedMessage } from 'react-intl';
import Tool_mealListWithoutSplit from '../../Components/Tools/Tool_mealListWithoutSplit';
import { Global } from '../../App';
import { AsyncModel, AsyncModelClose } from '../../Components/AsyncModel/AsyncModel';
import Tool_CusSp from '../../Components/Tools/Tool_CusSp';
import ReactLoading from 'react-loading';
import _ from 'lodash';
import '../../Pages/pages.scss';
// switch lang
import { langStringToCode } from '../../Share/Tools/switchLang';
// api
import { GetStaffMenuDetail } from '../../Api/GetProduct';
import { getTagList } from '../../Api/GetProduct';

const reducer = (state, { type, payload }) => {
  let newState = { ...state };
  switch (type) {
    case 'UPDATE_STATE':
      payload.forEach(i => {
        newState[i.key] = i.val;
      });
      return newState;
    default:
      return newState;
  }
};

function StaffMenuDetail(props) {
  const { globalState, dispatchGlobal } = useContext(Global);
  const [state, dispatch] = useReducer(reducer, {
    specificationData: null,
    specPopupSetting: {
      toggle: false,
      productName: '',
      specName: '',
      dineInTaste: [],
      takeoutTaste: [],
      disableTakeoutState: false
    },
    currModify: {},
    isLogin: false,
    currentCategory: null,
    toggleToolTips: false,
    searchInput: '',
    getApi: [],
    categoryList: [], // tab
    mealList: [], // meals
    tagList: {}, //tags
    tagSelected: [],
    tagPopupToggle: false
  });
  const _menuListRef = useRef([]);
  let _isEnabledScroll = useRef(true);
  let _isEnabledSlick = useRef(true);
  let _scrollRef = useRef(null);
  let _sliderRef = useRef(null);

  function handleScroll() {
    if (_isEnabledScroll.current) {
      _isEnabledSlick.current = false;
      const { _container: scrollContainer } = _scrollRef.current; // scrollArea
      // 當前整體高度 沒有超過scrollArea dom的index
      const firstEleIndex = _menuListRef.current.findIndex(ele => {
        return ele.offsetTop + ele.offsetHeight > scrollContainer.scrollTop;
      });
      // console.log(li[firstEleIndex], state.currentCategory, _menuListRef.current[firstEleIndex])
      if (state.mealList[firstEleIndex].type !== state.currentCategory.type) {
        console.log('set slick index');
        const goToIndex = state.categoryList.findIndex(
          item => item.type === state.mealList[firstEleIndex].type
        );
        _sliderRef.slickGoTo(goToIndex, true);
        dispatch({
          type: 'UPDATE_STATE',
          payload: [
            { key: 'currentCategory', val: state.categoryList[goToIndex] }
          ]
        });
      }
      setTimeout(() => {
        _isEnabledSlick.current = true;
      }, 0);
    } else {
      console.log('onSelecteding');
    }
  }
  async function apiGetStaffMenuDetail(langId, storeId) {
    try {
      const waittingAlert = AsyncModel({
        content: (
          <div className="w-100 d-flex justify-content-center">
            <ReactLoading
              type="spokes"
              color="#ccc"
              height="100px"
              width="100px"
            />
          </div>
        ),
        showConfirmBtn: false
      });
      const res = await GetStaffMenuDetail(langId, storeId);
      AsyncModelClose();
      const { errCode, product } = res.data;
      if (errCode == 200) {
        return product;
      } else {
        dispatchGlobal({
          type: 'UPDATE',
          payload: [{ key: 'errMsg', val: errCode }]
        });
        props.history.push('/staff/error');
      }
    } catch (err) {
      AsyncModelClose();
      console.error('Product error.');
      dispatchGlobal({
        type: 'UPDATE',
        payload: [{ key: 'errMsg', val: 407 }]
      });
      props.history.push('/staff/error');
    }
  }

  async function apiGetTagList(langId) {
    try {
      const res = await getTagList(langId);
      const { errCode, tagList } = res.data;
      if (errCode == 200) {
        return tagList;
      } else {
        console.error('GetTagList error.', errCode);
      }
    } catch (err) {
      console.error('GetTagList error.');
    }
  }

  // 檢查是否有店別
  useEffect(() => {
    const handle = async () => {
      let {
        checkOrderBranch
      } = globalState.staffInfo;
      if (!checkOrderBranch) {
        const alert = await AsyncModel({
          title: globalState.langFile['popup.msgLoginWarning'],
          confirmBtnText: globalState.langFile['popup.buttonConfirm']
        });
        if (alert) {
          dispatchGlobal({ type: 'RESET' });
          props.history.replace('/staffCheckOrder');
        }
      } else {
        dispatch({
          type: 'UPDATE_STATE',
          payload: [
            { key: 'isLogin', val: true }
          ]
        });
      }
    };
    handle();
  }, []);

  // get api
  useEffect(() => {
    if (globalState.staffInfo.checkOrderBranch) {
      const langCode = langStringToCode(globalState.langType);
      const productCode = globalState.staffInfo.staffProductId;
      async function handler() {
        const getProductItem = await apiGetStaffMenuDetail(langCode, productCode);

        if (getProductItem) {
          const mergeData = {
            ...getProductItem,
            specification: getProductItem.specification.map((item) => {
              return {
                ...item,
                combination: [{
                  quantity: 0,
                  takeout: false,
                  taste: []
                }]
              }
            })
          }
          dispatch({
            type: 'UPDATE_STATE',
            payload: [
              {
                key: 'specificationData',
                val: mergeData
                // val: merge(getProductItem.newSpecData)
              }
            ]
          });
          // dispatchGlobal({
          //   type: 'UPDATE',
          //   payload: [
          //     {
          //       key: 'customer',
          //       val: {
          //         ...globalState.customer,
          //         mealDetail: {
          //           ...globalState.customer.mealDetail,
          //           description: getProductItem.product.description,
          //           mealTag: getProductItem.product.allergen.concat(getProductItem.product.recommend),
          //           name: getProductItem.product.name,
          //           typeName: getProductItem.product.categoryName
          //         },
          //       }
          //     }
          //   ]
          // });
        }
      }
      handler();
    }
  }, [globalState.langType]);

  const $tabs = useMemo(() => {
    if (state.categoryList !== undefined) {
      let filterArray = [];
      // 有輸入關鍵字
      if (state.searchInput) {
        // 找出有該關鍵字的分類type
        filterArray = [...new Set(state.mealList
          // 關鍵字篩選
          .filter(f => {
            const target = state.searchInput;

            return (
              f.searchNum.toString().indexOf(target) > -1 ||
              f.name.toLowerCase().indexOf(target.toLowerCase()) > -1
            );
          })
          // 標籤篩選
          .filter(f => {
            // 沒有全選標籤時
            if (globalState.staffInfo.filterTag && globalState.staffInfo.filterTag.length &&
              globalState.staffInfo.filterTag.length !== state.tagList.allergen.length + state.tagList.recommend.length) {
              // 有篩選條件
              if (globalState.staffInfo.filterTag.length) {
                return globalState.staffInfo.filterTag.some(i => (
                  f.mealTag.map(m => (m.id)).includes(i)
                ))
              } else {
                return f.mealTag.length === 0;
              }
            } else {
              return true;
            }
          })
          .map(item => (item.type)))];

        // 轉換回文字
        const filterTabs = state.categoryList
          .filter(({ type: id1 }) =>
            filterArray.some((id2) =>
              id2 === id1
            ));

        // 有結果
        if (filterTabs.length) {
          return filterTabs.map(item => ({
            title: item.title,
            value: item.type
          }))
          // 查無結果，顯示全分類
        } else {
          return state.categoryList.map(item => ({
            title: item.title,
            value: item.type
          }))
        }
      } else {
        return state.categoryList.map(item => ({
          title: item.title,
          value: item.type
        }))
      }
    }
    return []
  }, [state.categoryList, state.searchInput, state.tagSelected])

  const $allTabs = useMemo(() => {
    if (state.categoryList !== undefined) {
      return state.categoryList.map(item => ({
        title: item.title,
        value: item.type
      }))
    }
    return []
  }, [state.categoryList])

  const $tabItems = useMemo(() => {
    if (state.mealList !== undefined) {
      if (state.searchInput) {
        // 輸入關鍵字移動到上方
        const { y } = document.getElementsByClassName('ScrollTabs')[0].getBoundingClientRect()
        document.body.scrollTo({
          top: document.body.scrollTop + y,
          behavior: 'smooth'
        })

        return state.mealList
          // 標籤篩選
          .filter(f => {
            // 沒有全選標籤時
            if (globalState.staffInfo.filterTag && globalState.staffInfo.filterTag.length &&
              globalState.staffInfo.filterTag.length !== state.tagList.allergen.length + state.tagList.recommend.length) {
              // 有篩選條件
              if (globalState.staffInfo.filterTag.length) {
                return globalState.staffInfo.filterTag.some(i => (
                  f.mealTag.map(m => (m.id)).includes(i)
                ))
              } else {
                return f.mealTag.length === 0;
              }
            } else {
              return true;
            }
          })
          // 關鍵字篩選
          .filter(f => {
            // if (state.searchInput) {
            const target = state.searchInput;
            return (
              f.searchNum.toString().indexOf(target) > -1 ||
              f.name.toLowerCase().indexOf(target.toLowerCase()) > -1
            );
            // } else {
            //   return [];
            // }
          })
          .map(item => ({
            $tab: item.type,
            ...item
          }))
      } else {
        return state.mealList
          // 標籤篩選
          .filter(f => {
            // 沒有全選標籤時
            if (globalState.staffInfo.filterTag && globalState.staffInfo.filterTag.length &&
              globalState.staffInfo.filterTag.length !== state.tagList.allergen.length + state.tagList.recommend.length) {
              // 有篩選條件
              if (globalState.staffInfo.filterTag.length) {
                return globalState.staffInfo.filterTag.some(i => (
                  f.mealTag.map(m => (m.id)).includes(i)
                ))
              } else {
                return f.mealTag.length === 0;
              }
            } else {
              return true;
            }
          })
          .map(item => ({
            $tab: item.type,
            ...item
          }))
      }
    }
    return []
  }, [state.mealList, state.searchInput, state.tagSelected])
  if (!state.specificationData) return null;
  return (
    <div className="Pages col d-flex flex-column align-items-center p-0 pt-3 pt-sm-0 mh-80">
      <div className="Pages__title mealInfo__title mb-3">
        {/* {globalState.customer.mealDetail.name} */}
        <DynamicFont content={state.specificationData.name} />
      </div>
      <div className="Pages__subtitle txtColorBrown mb-3">
        {state.specificationData.categoryName}
      </div>
      <div className="Pages__space w-100 mb-3">
      <div
          className="Pages__space__item w-100  p-2 p-sm-3 text-justify"
          dangerouslySetInnerHTML={{
            __html: state.specificationData.description,
          }}
        ></div>
         {/* <div className="Pages__space__item w-100 p-2 p-sm-3 text-justify">
          {globalState.customer.mealDetail.description}
         這段寫在後端 樣式可以調整mealInfo_desc_note的css
          <br />
          <div class="mealInfo_desc_note">※製餐時間較長，請耐心等候</div>
          <div></div>
        </div> */}
        
        <div className="Pages__mealsTagSpace">
          {state.specificationData.allergen.concat(state.specificationData.recommend).map(tagItem => (
            <div className="Pages__mealsTag p-1 mr-1 mb-1">
              <img
                style={{ height: '25px' }}
                className="mr-1"
                src={tagItem.icon}
                alt=""
              />
              <span>{tagItem.description}</span>
            </div>
          ))}
        </div>
      </div>
      <div className="Pages__mealsDetail Pages__section d-flex flex-column align-items-center">
        <div className="Pages__section">
          {/* 特口的規格 */}
          <Tool_mealListWithoutSplit
            user="staff"
            readOnly={true}
            device={globalState.device}
            data={state.specificationData}
            onDelete={async newData => {
              const alert = await AsyncModel({
                title: globalState.langFile['popup.msgDelete'],
                showCancelBtn: true,
                cancelBtnText: globalState.langFile['popup.buttonCancel'],
                confirmBtnText: globalState.langFile['popup.buttonConfirm']
              });
              if (alert) {
                dispatch({
                  type: 'UPDATE_STATE',
                  payload: [{ key: 'specificationData', val: newData.newData }]
                });
              }
            }}
            onUpdate={newData => {
              dispatch({
                type: 'UPDATE_STATE',
                payload: [
                  {
                    key: 'specificationData',
                    val: newData
                  }
                ]
              });
            }}
            onEditTaste={newData => {
              dispatch({
                type: 'UPDATE_STATE',
                payload: [
                  {
                    key: 'specPopupSetting',
                    val: newData.specPopupSetting
                  },
                  {
                    key: 'currModify',
                    val: newData.currModify
                  }
                ]
              });
            }}
            onAddNewSpec={newCurrModify => {
              dispatch({
                type: 'UPDATE_STATE',
                payload: [
                  {
                    key: 'specPopupSetting',
                    val: newCurrModify.specPopupSetting
                  },
                  {
                    key: 'isAddNew',
                    val: newCurrModify.isAddNew
                  },
                  {
                    key: 'currModify',
                    val: newCurrModify.currModify
                  }
                ]
              });
              // const newData = _.cloneDeep(state.specificationData);
              // const whichTaste = newCurrModify.currModify.takeout
              //   ? newData.takeoutTaste
              //   : newData.stayInTaste;
              // let findSpce = newData.specification.find(
              //   target => target.id === newCurrModify.currModify.specId
              // );
              // // 新增一個含預設特口的組合到該規格
              // findSpce.combination = [
              //   ...findSpce.combination,
              //   {
              //     takeout: newCurrModify.currModify.takeout,
              //     taste: whichTaste.filter(def => def.preset).map(e => e.id),
              //     quantity: newCurrModify.currModify.quantity
              //   }
              // ];
              // dispatch({
              //   type: 'UPDATE_STATE',
              //   payload: [
              //     {
              //       key: 'specificationData',
              //       val: merge(newData)
              //     }
              //   ]
              // });
            }}
          />
        </div>
      </div>
      <div className="Pages__section d-flex justify-content-center mt-4 mb-4">
        <CusButton.White
          className="p-3 pl-sm-5 pr-sm-5 mt-2 mb-2 col col-sm-auto"
          children={
            <FormattedMessage id="pages.staffMenuDetail.buttonBack" />
          }
          onClick={() => {
            window.history.back()
          }}
        />
      </div>

      {/* 特口彈跳視窗 */}
      {(() => {
        if (!state.specPopupSetting.toggle) return null;
        return (
          <Tool_CusSp
            productName={state.specPopupSetting.productName}
            specName={state.specPopupSetting.specName}
            takeoutTaste={state.specPopupSetting.takeoutTaste}
            dineInTaste={state.specPopupSetting.dineInTaste}
            takeoutState={state.specPopupSetting.applyMode === 3 ? true : state.currModify.takeout} // 若僅限外帶，預設給true
            disableTakeoutState={state.specPopupSetting.disableTakeoutState}
            disableConfirmBtn={true}
            applyModeState={state.specPopupSetting.applyMode}
            selectedItems={state.currModify.taste}
            onClose={e => {
              dispatch({
                type: 'UPDATE_STATE',
                payload: [
                  {
                    key: 'specPopupSetting',
                    val: {
                      toggle: false,
                      productName: '',
                      specName: '',
                      dineInTaste: [],
                      takeoutTaste: []
                    }
                  },
                  { key: 'currModify', val: {} },
                  { key: 'isAddNew', val: false }
                ]
              });
            }}
          // onSelectItem={e => {
          //   e.taste.sort();
          //   let deep = _.cloneDeep(state.specificationData);
          //   let { specification } = deep;
          //   // 是否為新增組合
          //   if (state.isAddNew) {
          //     let findCurrentSpec = specification.find(
          //       f => f.id === state.currModify.specId
          //     );

          //     // takeout: 可能需要改 e.applyMode === 3
          //     findCurrentSpec.combination = [
          //       ...findCurrentSpec.combination,
          //       {
          //         takeout: e.takeoutState,
          //         taste: e.taste,
          //         quantity: 1
          //       }
          //     ];
          //     dispatch({
          //       type: 'UPDATE_STATE',
          //       payload: [
          //         {
          //           key: 'specificationData',
          //           val: merge(deep)
          //         },
          //         {
          //           key: 'specPopupSetting',
          //           val: {
          //             toggle: false,
          //             productName: '',
          //             specName: '',
          //             dineInTaste: [],
          //             takeoutTaste: []
          //           }
          //         },
          //         { key: 'currModify', val: {} },
          //         { key: 'isAddNew', val: false }
          //       ]
          //     });
          //   } else {
          //     specification.map(_eachSp => {
          //       if (_eachSp.id === state.currModify.specId) {
          //         // 找到當前要修改的combination
          //         let findCurrentCombi = _eachSp.combination.find(f => {
          //           return (
          //             f.takeout === state.currModify.takeout &&
          //             f.taste.sort().toString() ===
          //             state.currModify.taste.sort().toString() &&
          //             f.quantity === state.currModify.quantity
          //           );
          //         });
          //         console.log(findCurrentCombi, state.currModify, e);
          //         // 更新當前要修改的combination的特口
          //         if (
          //           findCurrentCombi.taste.sort().toString() !==
          //           e.taste.sort().toString() ||
          //           findCurrentCombi.takeout !== e.takeoutState
          //         ) {
          //           findCurrentCombi.taste = e.taste;
          //           findCurrentCombi.takeout = e.takeoutState;

          //           dispatch({
          //             type: 'UPDATE_STATE',
          //             payload: [
          //               {
          //                 key: 'specificationData',
          //                 val: merge(deep)
          //               },
          //               {
          //                 key: 'specPopupSetting',
          //                 val: {
          //                   toggle: false,
          //                   productName: '',
          //                   specName: '',
          //                   dineInTaste: [],
          //                   takeoutTaste: []
          //                 }
          //               },
          //               { key: 'currModify', val: {} },
          //               { key: 'isAddNew', val: false }
          //             ]
          //           });
          //         }
          //       }
          //     });
          //   }
          // }}
          />
        );
      })()}
    </div>
  );
}

export default StaffMenuDetail;
